import type { ConnectedAccountsApiResponse } from '@/lib/publish/connectedAccountsTypes';

export const connectedAccountsQueryKey = ['connected-accounts'] as const;

export async function fetchConnectedAccountsClient(): Promise<ConnectedAccountsApiResponse> {
  const res = await fetch('/api/connected-accounts', {
    method: 'GET',
    credentials: 'include',
    cache: 'no-store',
  });
  if (res.status === 401) {
    throw new Error('Unauthorized');
  }
  if (!res.ok) {
    const t = await res.text().catch(() => '');
    throw new Error(t || `HTTP ${res.status}`);
  }
  return (await res.json()) as ConnectedAccountsApiResponse;
}
